/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import { pluralize, Icon } from 'sarsaparilla';

import { CartTimer } from './CartTimer';

import styles from './CartIndicator.module.scss';

export type CartIndicatorProps = {
    expiration?: string;
    showTimer?: boolean;
    reservationCount?: number;
};

export function CartIndicator({
    expiration,
    showTimer = false,
    reservationCount = 0,
}: CartIndicatorProps) {
    const numCartItems = reservationCount;
    const cartAriaLabel =
        numCartItems > 0
            ? `Cart - ${numCartItems} ${pluralize(
                  numCartItems,
                  'item',
                  'items'
              )} in cart.`
            : 'Cart';

    return (
        <div className={styles.cartIndicator}>
            <a
                aria-label={cartAriaLabel}
                href="/cart"
                className={styles.cartLink}
                id="ga-global-nav-account-cart-link"
            >
                <Icon
                    iconName="cart"
                    className={cx({ [styles.hasBadge]: numCartItems > 0 })}
                />
                {numCartItems > 0 && (
                    <span className={styles.cartQuantity}>{numCartItems}</span>
                )}
            </a>

            {showTimer && (
                <div className="rec-small-timer">
                    {expiration && (
                        <CartTimer
                            date={new Date(expiration)}
                            reservationCount={numCartItems}
                        />
                    )}
                </div>
            )}
        </div>
    );
}
